import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();
  return (
    <footer data-testid="footer" className="bg-[#1B3D2F] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-20">
        <div className="flex flex-col items-center text-center">
          <img
            src="https://customer-assets.emergentagent.com/job_abule-imole/artifacts/6soepudp_Cooperative.png"
            alt="Abule Imole Village of Light"
            className="h-20 sm:h-32 w-auto"
            style={{ filter: 'brightness(0) invert(75%) sepia(15%) saturate(500%) hue-rotate(60deg) brightness(0.85)' }}
          />
          <p className="text-white/60 text-base sm:text-lg leading-relaxed max-w-md mt-6 mb-8">{t.footer.tagline}</p>
          <div className="flex flex-wrap items-center justify-center gap-6 sm:gap-10">
            {[
              { label: t.nav.home, path: "/" },
              { label: t.nav.about, path: "/about" },
              { label: t.nav.book, path: "/book" },
              { label: t.nav.events, path: "/events" },
              { label: t.nav.contact, path: "/contact" },
            ].map((link) => (
              <Link key={link.path} to={link.path} data-testid={`footer-link-${link.path.replace("/", "") || "home"}`} className="text-white/60 hover:text-[#C4883A] text-base sm:text-lg transition-colors duration-200">
                {link.label}
              </Link>
            ))}
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 text-center">
          <p className="text-white/40 text-xs sm:text-sm flex items-center justify-center gap-1 flex-wrap">
            &copy; {new Date().getFullYear()} {t.footer.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
}
